<template>
  <div
    class="c-product-card-rank-badge"
    :class="[`rank${rankNumber}`, size]"
  ></div>
</template>

<script>
export default {
  name: 'ComponentsProductCardRankBadge',
  props: {
    rankNumber: { type: Number, required: true, default: 1 },
    size: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-product-card-rank-badge {
  border-radius: 15px;
  display: block;
  text-align: center;
  z-index: 1;

  @for $i from 1 through 3 {
    &.rank#{$i} {
      background-color: rgba(#fff, 0.5);
      background-image: url('~/images/rank_image_#{$i}.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 30px;
      height: 40px;
      width: 40px;

      &.small {
        background-size: 22px;
        height: 30px;
        width: 30px;
      }
    }
  }

  @for $i from 4 through 100 {
    &.rank#{$i} {
      background-color: variables.$color-pink;
      display: block;
      height: 28px;
      line-height: 28px;
      text-align: center;
      width: 28px;

      &::before {
        content: '#{$i}';
      }

      &.small {
        height: 24px;
        line-height: 24px;
        width: 24px;
      }
    }
  }
}
</style>
